import {Option} from './select';

export default function createOption(value: string, label?: string): Option {
    return {value: value, label: label ? label : value};
}
